import { handleActions } from 'redux-actions';
import { reduxKey } from './constants';
const handler = handleActions({}, {});
const reducers = {
    [`${reduxKey}`]: handler
};
export default reducers;

//# sourceMappingURL=reducers.js.map